import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useTheme } from "../contexts/ThemeContext";

export function LanguageToggle({ forceLight }: { forceLight?: boolean }) {
  const { i18n } = useTranslation();
  const { theme } = useTheme();
  const isDark = theme === "dark";
  const color = forceLight || isDark ? "#f5f5f5" : "#171717";

  const language = i18n.language?.startsWith("th") ? "th" : "en";
  const toggleLanguage = () => {
    const body = document.body;
    body.classList.remove("lang-switched");
    body.classList.add("lang-switching");

    setTimeout(() => {
      i18n.changeLanguage(language === "en" ? "th" : "en");
      body.classList.remove("lang-switching");
      body.classList.add("lang-switched");
      setTimeout(() => body.classList.remove("lang-switched"), 240);
    }, 180);
  };

  return (
    <button
      onClick={toggleLanguage}
      className="relative flex items-center justify-center w-9 h-9 rounded-full transition-opacity hover:opacity-70"
      style={{ color }}
      aria-label={language === "en" ? "Switch to Thai" : "Switch to English"}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.span
          key={language}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          className="text-[12px] font-semibold tracking-wide"
        >
          {language === "th" ? "TH" : "EN"}
        </motion.span>
      </AnimatePresence>
    </button>
  );
}
